import {
  decryptEncryptValue,
  generateDecryptValue,
  generateEncryptedValue,
} from "../constants/vtrTrip";
import { ENCRYPT_VALUE, DECRYPT_VALUE } from "../constants/Encrypt";

export const getIvrTripKey = (seed) => {
  return `ivrList_${seed}`;
};

function encryptDecryptIvr(payload, seed, actionType, encrypt_decrypt) {
  let encryptedPayload = {
    form_name: decryptEncryptValue(payload.form_name, seed, encrypt_decrypt),
    form_version: decryptEncryptValue(
      payload.form_version.toString(),
      seed,
      encrypt_decrypt
    ),
    vessel_permit_num: decryptEncryptValue(
      payload.vessel_permit_num,
      seed,
      encrypt_decrypt
    ),
  };

  if (payload.hasOwnProperty("trip_id")) {
    encryptedPayload = {
      ...encryptedPayload,
      trip_id: decryptEncryptValue(payload.trip_id.toString(), seed, encrypt_decrypt),
    };
  }

  if (actionType === "das_open") {
    let encryptedAreas = [];

    if (payload.hasOwnProperty("brdstck_area")) {
      const brdstckArea = payload.brdstck_area;
      encryptedAreas = brdstckArea.map((keyName) => {
        return {
          area: decryptEncryptValue(keyName.area, seed, encrypt_decrypt),
        };
      });
    }
    encryptedPayload = {
      ...encryptedPayload,
      offloading_port: decryptEncryptValue(
        payload.offloading_port,
        seed,
        encrypt_decrypt
      ),
      speciescd: decryptEncryptValue(payload.speciescd, seed, encrypt_decrypt),
      sthrn_mgmt_area_flg: decryptEncryptValue(
        payload.sthrn_mgmt_area_flg,
        seed,
        encrypt_decrypt
      ),
      gear_type: decryptEncryptValue(payload.gear_type, seed, encrypt_decrypt),
      ne_multiflg: decryptEncryptValue(payload.ne_multiflg, seed, encrypt_decrypt),
      brdstck_area: encryptedAreas,
    };
  } else if (actionType === "das_close") {
    encryptedPayload = {
      ...encryptedPayload,
      offloading_port: decryptEncryptValue(
        payload.offloading_port,
        seed,
        encrypt_decrypt
      ),
      catchcomp: decryptEncryptValue(payload.catchcomp, seed, encrypt_decrypt),
      mnkfsh_ovrgflg: decryptEncryptValue(payload.mnkfsh_ovrgflg, seed, encrypt_decrypt),
      lbs: decryptEncryptValue(payload.lbs, seed, encrypt_decrypt),
    };
  } else if (actionType === "das_open_block") {
    encryptedPayload = {
      ...encryptedPayload,
      offloading_port: decryptEncryptValue(
        payload.offloading_port,
        seed,
        encrypt_decrypt
      ),
      block_start_date: decryptEncryptValue(
        payload.block_start_date,
        seed,
        encrypt_decrypt
      ),
      block_end_date: decryptEncryptValue(payload.block_end_date, seed, encrypt_decrypt),
      block_type: decryptEncryptValue(payload.block_type, seed, encrypt_decrypt),
    };
  } else if (actionType === "efp_close") {
    let encryptedCatch = [];

    if (payload.hasOwnProperty("catch")) {
      encryptedCatch = payload.catch;
      encryptedCatch = encryptedCatch.map(function ({
        ivr_species,
        kept,
        discarded,
        uom,
      }) {
        return {
          ivr_species: decryptEncryptValue(ivr_species, seed, encrypt_decrypt),
          kept: decryptEncryptValue(kept, seed, encrypt_decrypt),
          discarded: decryptEncryptValue(discarded, seed, encrypt_decrypt),
          uom: decryptEncryptValue(uom, seed, encrypt_decrypt),
        };
      });
    }
    encryptedPayload = {
      ...encryptedPayload,
      vtrnbr: decryptEncryptValue(payload.vtrnbr, seed, encrypt_decrypt),
      statecd: decryptEncryptValue(payload.statecd, seed, encrypt_decrypt),
      catch: encryptedCatch,
    };
  } else if (actionType === "rsa_close") {
    let encryptedCatch = [];

    if (payload.hasOwnProperty("catch")) {
      encryptedCatch = payload.catch;
      encryptedCatch = encryptedCatch.map(function ({ ivr_species, kept, uom }) {
        return {
          ivr_species: decryptEncryptValue(ivr_species, seed, encrypt_decrypt),
          kept: decryptEncryptValue(kept, seed, encrypt_decrypt),
          uom: decryptEncryptValue(uom, seed, encrypt_decrypt),
        };
      });
    }
    encryptedPayload = {
      ...encryptedPayload,
      est_trip_end_date: decryptEncryptValue(
        payload.est_trip_end_date,
        seed,
        encrypt_decrypt
      ),
      mnkfsh_ovrgflg: decryptEncryptValue(payload.mnkfsh_ovrgflg, seed, encrypt_decrypt),
      offloading_port: decryptEncryptValue(
        payload.offloading_port,
        seed,
        encrypt_decrypt
      ),
      rsa_project_code: decryptEncryptValue(
        payload.rsa_project_code,
        seed,
        encrypt_decrypt
      ),
      vtrnbr: decryptEncryptValue(payload.vtrnbr, seed, encrypt_decrypt),
      statecd: decryptEncryptValue(payload.statecd, seed, encrypt_decrypt),
      catch: encryptedCatch,
    };
  } else {
    if (payload.hasOwnProperty("rsa_project_code")) {
      encryptedPayload = {
        ...encryptedPayload,
        rsa_project_code: decryptEncryptValue(
          payload.rsa_project_code,
          seed,
          encrypt_decrypt
        ),
        est_trip_end_date: decryptEncryptValue(
          payload.est_trip_end_date,
          seed,
          encrypt_decrypt
        ),
        offloading_port: decryptEncryptValue(
          payload.offloading_port,
          seed,
          encrypt_decrypt
        ),
        gear_type: decryptEncryptValue(payload.gear_type, seed, encrypt_decrypt),
      };
    } else if (payload.hasOwnProperty("efp_project_code")) {
      encryptedPayload = {
        ...encryptedPayload,
        efp_project_code: decryptEncryptValue(
          payload.efp_project_code,
          seed,
          encrypt_decrypt
        ),
      };
    }
  }
  return encryptedPayload;
}

export const saveIvrTrip = (seed, actionType, url, payload) => {
  const localStorageKey = getIvrTripKey(seed);
  let encryptString = ENCRYPT_VALUE;
  let encryptedPayload = encryptDecryptIvr(payload, seed, actionType, encryptString);

  const storedTrips = {
    type: generateEncryptedValue(actionType, seed),
    payload: encryptedPayload,
    url: generateEncryptedValue(url, seed),
  };
  console.log("Encrypted Trip JSON", storedTrips);
  localStorage.setItem(localStorageKey, JSON.stringify(storedTrips));
};

export const loadIvrTrip = (seed) => {
  const localStorageKey = getIvrTripKey(seed);
  const encryptString = DECRYPT_VALUE;
  let rawSavedTrip = localStorage.getItem(localStorageKey);
  let storedTrip = {};

  if (rawSavedTrip) {
    const savedTrip = JSON.parse(rawSavedTrip);
    const actionType = generateDecryptValue(savedTrip.type, seed);
    const decryptedPayload = encryptDecryptIvr(
      savedTrip.payload,
      seed,
      actionType,
      encryptString
    );

    storedTrip = {
      type: actionType,
      payload: decryptedPayload,
      url: generateDecryptValue(savedTrip.url, seed),
    };
    console.log("Decrypted Trip JSON", storedTrip);
  }

  return storedTrip;
};
